/* @flow */

const segment = (state) => state.app.signup;

export const selectSignupCode = (state: Object): string => segment(state).code;

export const selectSignupEmail = (state: Object): string =>
  segment(state).email;

export const selectIsPasswordSet = (state: Object): boolean =>
  segment(state).isPasswordSet;
